import { forwardRef } from "react";
import Text from "../text";
import { jsxs as _jsxs } from "react/jsx-runtime";
function roundWithPrecision(value, precision) {
  const p = 10 ** precision;
  return Math.round((value + Number.EPSILON) * p) / p;
}
function roundWithSignificance(value) {
  if (value < 10) {
    return roundWithPrecision(value, 2);
  }
  if (value < 100) {
    return roundWithPrecision(value, 1);
  }
  return roundWithPrecision(value, 0);
}
function formatNumber(value) {
  const kl = roundWithSignificance(value / 1000);
  const ml = roundWithSignificance(kl / 1000);
  const bl = roundWithSignificance(ml / 1000);
  const tl = roundWithSignificance(bl / 1000);
  if (tl >= 1) {
    return tl + "T";
  }
  if (bl >= 1) {
    return bl + "B";
  }
  if (ml >= 1) {
    return ml + "M";
  }
  if (kl >= 1) {
    return kl + "K";
  }
  return roundWithSignificance(value).toString();
}
export const CompactNumber = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    prefix,
    suffix,
    ...rest
  } = _ref;
  const title = Number(value).toLocaleString();
  return /*#__PURE__*/_jsxs(Text, {
    ref: ref,
    fontFamily: "secondary",
    ...rest,
    title: title,
    children: [prefix, formatNumber(value), suffix]
  });
});
export default Object.assign(CompactNumber, {
  formatNumber
});